import React from "react";
import './ArticlePage.css'

const ArticlePage2 = () => {
  return <div className="article-texts"> Information to be added</div>;
};

export default ArticlePage2;
